import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  ViewChild,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ExpandedThemesComponent } from '../../shared/components/sections/expanded-themes/expanded-themes.component';
import { SmallHeaderComponent } from '../../shared/partials/small-header/small-header.component';
import { HeroBannerComponent } from '../../shared/components/hero-banner/hero-banner.component';
import { ButtonComponent } from '../../shared/components/buttons/button/button.component';
import { DestinationsService } from '../../reducers/services/destinations.service';
import { PropertyCardComponent } from '../../shared/components/cards/property-card/property-card.component';
import { HotelListingCardComponent } from '../hotel-listing-card/hotel-listing-card.component';
import { SectionTitleComponent } from '../../shared/components/ui-elements/section-title/section-title.component';
import { TabComponent } from '../../shared/components/tab/tab.component';
import { PropertyCardCarouselComponent } from '../../shared/components/carousels/property-card-carousel/property-card-carousel.component';
import { DiningsCardCarouselComponent } from '../dinings-card-carousel/dinings-card-carousel.component';
import { WellnessCardComponent } from '../../shared/components/cards/wellness-card/wellness-card.component';

@Component({
  selector: 'app-dinings-page',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    SmallHeaderComponent,
    HeroBannerComponent,
    SectionTitleComponent,
    TabComponent,
    PropertyCardCarouselComponent,
    DiningsCardCarouselComponent,
    WellnessCardComponent,
  ],
  templateUrl: './wellness-page.component.html',
  styleUrl: './wellness-page.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WellnessPageComponent {
  latestSpas: any[] = [];
  isTocExpanded = false;
  totalCount: number = 0;
  slug: string = '';
  page = 1;
  limit = 9;
  blogContainerId = 'blog-search-container';
  query = '';
  upcominghotels: any[] = [];
  tabs: any[] = [];

  private platformId = inject(PLATFORM_ID);
  destinations: any[] = [];
  loading = false;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute,
    private destinationService: DestinationsService
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.fetchDinings();

      this.scrollToTop();
    }
  }

  scrollToTop() {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  fetchDinings(): void {
    // this.destinationService.getHotels('').subscribe((res) => {
    //   this.latestSpas = res?.data;
    //   this.totalCount = res?.totalCount;
    //   console.log('this.latestSpas', this.latestSpas);

    //   this.page++;
    // });
    this.latestSpas = [
      {
        id: 1,
        name: 'Spa 1',
        cityInfo: { name: 'City 1' },
        banners: 'assets/images/banners/kera-spa-1.jpg',
        offers: [
          {
            title: 'Head Massage',
            timing: '30 mins',
          },
          {
            title: 'Back, Neck & Shoulder Massage',
            timing: '45 mins',
          },
          {
            title: 'Foot Massage',
            timing: '30 mins',
          },
        ],
      },
      {
        id: 2,
        name: 'Spa 2',
        cityInfo: { name: 'City 2' },
        banners: 'assets/images/banners/kera-spa-2.png',
        offers: [
          {
            title: 'Deep Muscle/Tissue Massage',
            timing: '45 mins',
          },
          {
            title: 'Aroma Therapy - Essential Oil Body Melt',
            timing: '45 mins',
          },
          {
            title: 'Swedish Massage - Stress Buster',
            timing: '45 mins',
          },
          {
            title: 'Signature Massage',
            timing: '45 mins',
          },
        ],
      },
    ];
  }
}
